export default {"paymentMethods":"vF2mn","title":"EwKQG","list":"eCHtb","option":"BKJKX","lightTheme":"-aIxK"};